
<template>
  <div style="margin-top: 10px">
    <div class="validation-section" id="formulario">
      <div class="row">
        <div class="col-md-12">
          <label>Ingrese la Patente</label>
        </div>
      </div>
      <div class="row" style="margin-bottom: 0">
        <div class="col-md-12" style="padding-right: 5px">
          <base-input
            v-model="model.Aux1"
            :disabled="this.disabledFormulario"
            @blur="change"
            onkeyup="javascript:this.value=this.value.toUpperCase();"
          ></base-input>
        </div>
      </div>
      <div class="row" style="margin-top: 0">
        <div class="col-md-12">
          <label>Calle</label>
        </div>
      </div>
      <div class="row" style="margin-bottom: 5">
        <div class="col-md-12" style="padding-right: 10px">
          <KitsCombo
            v-model="SelectedCalleID"
            v-on:input="change"
            :disabled="this.disabledFormulario"
            v-bind:items="calles"
            propertyName="Nombre"
            propertyID="EntityID"
            nullText=" -- Seleccione una calle -- "
            :todos="true"
          ></KitsCombo>
        </div>
      </div>
      <div class="row" style="padding-top: 20px">
        <div class="col-md-12">
          <label>Ingrese la altura</label>
        </div>
      </div>
      <div class="row" style="margin-bottom: 5">
        <div class="col-md-12" style="padding-right: 10px">
          <KitsCombo
            :disabled="this.disabledComboCuadras"
            v-model="SelectedAlturaID"
            v-on:input="change"
            v-bind:items="cuadrasFiltradas"
            propertyName="Altura"
            propertyID="EntityID"
            nullText=" -- Seleccione una altura -- "
            :todos="true"
          ></KitsCombo>
        </div>
      </div>
      <div class="row" style="margin-top: 5; padding-top: 20px">
        <div class="col-md-12" style="padding-right: 10px">
          <label>Ingrese el tiempo a estacionar</label>
        </div>
      </div>
      <div
        class="row"
        style="
          margin-left: auto;
          margin-right: auto;
          display: block;
          padding-right: 10px;
        "
      >
        <div class="col-md-11 col-sm-8 col-xs-6">
          <resimple-slider
            class="resimple-slider"
            :disabled="this.disabledFormulario"
            v-model="model.Aux2"
            v-on:input="change"
            :range="ammountRange"
            :interval="intervalo"
          />
          <div class="col-md-12" style="font-weight: bold">
            <label>{{ this.Minutos.toString() }} minutos</label>
          </div>
          <div class="row mb-2">
            <div class="col-md-12 text-center">
              <span>
                Selecciona los minutos que desee estacionar entre
                {{ this.ammountRange.min }} y {{ this.ammountRange.max }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="text-align: right">
        <div class="col-md-6">
          <base-button
            type="warning"
            :disabled="this.disabledFormulario"
            size="lg"
            @click="validateUser"
            style="margin: auto; margin-top: 10px"
          >
            <i class="fa fa-check fa-fw"></i>Validar
          </base-button>
        </div>
      </div>
    </div>

    <div class="recarga-section text-center">
      <div class="row text-center" style="margin: 10px auto auto">
        <div v-show="this.model.Validate" class="col-md-12">
          <div class="row text-center" style="font-weight: bold">
            <label>Zona: {{ Zona }}</label>
          </div>
          <div class="row text-center" style="font-weight: bold">
            <label>Importe :{{ Importe }}</label>
          </div>
          <div class="row text-center" style="font-weight: bold">
            <label class="text-center">Hora Finalizada: {{ HoraFinalizada }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="text-align: right">
      <div class="col-md-6">
        <base-button
          type="warning"
          :disabled="!this.disabledFormulario"
          size="lg"
          @click="anularValidacion"
          style="margin: auto; margin-top: 10px"
        >
          <i class="fa fa-check fa-fw"></i>Anular Validacion
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";

import KitsCombo from "@/components/KitsCombo";
import MoneyWithIndicator from "@/components/Custom/MoneyWithIndicator";
import ResimpleSlider from "@/components/Custom/ResimpleSlider";
import { isNullOrUndefined, isNull } from "util";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  components: {
    KitsCombo,
    MoneyWithIndicator,
    "resimple-slider": ResimpleSlider,
    notificationHelpers
  },
  props: {
    model: {
      Aux1: "",
      Aux2: "",
      Aux3: "",
      Aux4: "",
      Importe: 0,
      Validate: false,
      Errors: []
    }
  },

  data() {
    return {
      SelectedCalleID: null,
      SelectedAlturaID: null,
      cuadras: [],
      cuadrasFiltradas: [],
      calles: [],
      zona: "",
      intervalo: 5,
      disabledComboCuadras: true,
      importeDisabled: true,
      Zona: "",
      disabledValidar: false,
      disabledFormulario: false,
      Importe: "",
      Minutos: 60,
      patenteVieja : /^[a-zA-Z]{3}[0-9]{3}$/,
      patenteNueva : /^[a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2}$/,
      HoraFinalizada: "",
      validatePrice: false,
      price: "",
      ammountRange: {
        min: 60,
        max: 180
      }
    };
  },

  beforeMount() {
    this.cargarDatos();
  },

  mounted(){
      this.model.Aux2 = this.Minutos;
  },

  methods: {
    async cargarDatos() {
      let context = this;
      axiosHelpers.axiosGet("Recarga/GetParkingSPK", {}, context, function(
        data
      ) {
        context.cuadras = data.ResponseVM.Cuadras;
        context.calles = data.ResponseVM.Calles;
        context.SelectedCalleID = null;
        context.SelectedAlturaID = null;
      });
    },
    change(element) {
      this.validate();
      this.$emit("input", this.model);
    },
    onSaldoOK(val) {
      this.$emit("saldoOK", val);
    },
    validateUser() {
      let context = this;
      
      context.validateInterno();
      if (context.model.Errors.length == 0) {
        axiosHelpers.axiosGet(
          "Recarga/ValidateSPK",
          {
            CuadraID: parseInt(context.model.Aux3),
            Tiempo: parseInt(context.model.Aux2),
            Patente: this.model.Aux1,
            Importe: 0
          },
          context,
          function(data) {
            context.validated = false;
            if (data.Alerts.length == 0) {
              context.Zona = data.ResponseVM.NombreZona;
              context.Importe = data.ResponseVM.Importe;
              context.HoraFinalizada = data.ResponseVM.HoraFin;
              context.model.Importe = data.ResponseVM.ImporteDecimal;
              context.validatePrice = true;
              context.model.Validate = true;
              context.disabledFormulario = true;
              context.disabledComboCuadras = true;
            } else {
              context.model.Validate = false;
              context.validatePrice = false;
              context.disabledFormulario = false;
            }
          }
        );
      } else {
        context.model.Errors.forEach(element => {
          notificationHelpers.showError("Error", element, this);
        });
      }
      context.$emit("input", context.model);
    },
    validateInterno() {
      let context = this;
      context.model.Errors = [];
      if (context.model.Aux1 == null || context.model.Aux1.length == 0) {
        context.model.Validate = false;
        context.model.Errors.push("Debe ingresar Patente");
      } else if (
        !(
          this.patenteVieja.test(context.model.Aux1) ||
          this.patenteNueva.test(context.model.Aux1)
        )
      ) {
        context.model.Validate = false;
        context.model.Errors.push(
          "La patente tiene un formato invalido debe ser en formato ABC123 o AB123CD"
        );
      } else if (context.model.Aux1.length < 5) {
        context.model.Validate = false;
        context.model.Errors.push(
          "La patente debe tener al menos 5 caracteres"
        );
      } else if (
        this.SelectedCalleID == null ||
        this.SelectedCalleID == undefined ||
        isNaN(this.SelectedCalleID) ||
        this.SelectedCalleID == 0
      ) {
        context.model.Validate = false;
        context.model.Errors.push("Debe elegir alguna Calle");
      } else if (
        isNull(this.SelectedAlturaID) ||
        isNaN(this.SelectedAlturaID) ||
        this.SelectedAlturaID == 0
      ) {
        context.model.Validate = false;
        context.model.Errors.push("Debe elegir alguna Altura");
      } else if (
        this.Minutos == null ||
        this.Minutos == 0 ||
        isNaN(this.Minutos) ||
        (this.Minutos < 60 && this.Minutos > 180)
      ) {
        context.model.Validate = false;
        context.model.Errors.push(
          "La cantidad de minutos deben ser entre 60 y 180 "
        );
      } else {
        this.model.Errors = [];
      }
    },
    validate() {
      let context = this;
      context.validateInterno();
      if (!context.validatePrice) {
        context.model.Validate = false;
        context.model.Errors.push(
          "Debes validar el importe antes de realizar la recarga"
        );
      }
    },
    anularValidacion() {
      let context = this;
      context.disabledFormulario = false;
      context.disabledComboCuadras = false;
      context.Zona = "";
      context.Importe = "";
      context.HoraFinalizada = "";
      context.model.Importe = 0;
      context.validatePrice = false;
      context.model.Validate = false;
      context.SelectedCalleID = null;
      context.SelectedAlturaID = null;
      context.model.aux2 = null;
    }
  },

  watch: {
    "model.Aux4": function(newValue, oldValue) {
      this.disabledComboCuadras = false;
      if (isNaN(newValue) || isNullOrUndefined(newValue) || newValue == 0) {
        this.disabledComboCuadras = true;
        this.model.Aux4 = null;
      }
      if (oldValue != undefined && oldValue != null && newValue != oldValue) {
        this.cuadrasFiltradas = this.cuadras.filter(
          item => item.CalleID == newValue
        );
      }
    },

    SelectedCalleID: function(newValue, oldValue) {
      if (newValue == null) {
        this.model.Aux4 = null;
      }
      this.model.Aux4 = newValue.toString();
    },

    SelectedAlturaID: function(newValue, oldValue) {
      if (newValue == null) {
        this.model.aux3 = null;
      }
      this.model.Aux3 = newValue.toString();
    },
    "model.Aux2": function(newValue, oldValue) {
      this.Minutos = newValue.toString();
    }
  }
};
</script>